import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const ResponseModal = ({ openModal, respond, handleCancel }) => {

    return (
        <div>
            <Modal
                show={openModal}
                onHide={handleCancel}
                backdrop="static"
                keyboard={false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='show-respond'>
                        {respond}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCancel}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ResponseModal